import EA from '../helpers/init';
import { createApp } from 'vue';

export default EA.Methods.wakeLock = ($this) => {
    const wakeLockToggle = $this.querySelector('#wakeLockToggle');

    if (!wakeLockToggle) {
        console.warn('wakeLock: #wakeLockToggle nije pronađen');
        return;
    }

    let wakeLock = null;
    let wakeLockEnabled = false;

    const requestWakeLock = async () => {
        if (!('wakeLock' in navigator)) {
            console.warn('Wake Lock nije podržan u ovom browseru.');
            wakeLockToggle.checked = false;
            wakeLockEnabled = false;
            return;
        }

        try {
            wakeLock = await navigator.wakeLock.request('screen');
            wakeLockEnabled = true;

            console.log('Wake Lock upaljen');

            wakeLock.addEventListener('release', () => {
                wakeLock = null;
                console.log('Wake Lock ugašen od strane browsera');
            });
        } catch (error) {
            wakeLock = null;
            wakeLockEnabled = false;
            wakeLockToggle.checked = false;

            console.error('Wake Lock error:', error);
        }
    };

    const releaseWakeLock = async () => {
        wakeLockEnabled = false;

        if (wakeLock) {
            await wakeLock.release();
            wakeLock = null;
        }

        console.log('Wake Lock ručno ugašen');
    };

    wakeLockToggle.addEventListener('change', async () => {
        if (wakeLockToggle.checked) {
            await requestWakeLock();
        } else {
            await releaseWakeLock();
        }
    });

    document.addEventListener('visibilitychange', async () => {
        if (
            wakeLockEnabled &&
            document.visibilityState === 'visible' &&
            !wakeLock
        ) {
            await requestWakeLock();
        }
    });
};